module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"power":"Leistung","constantCurrent":"Konstant&shy;strom","constantVoltage":"Konstant&shy;spannung","dimmable":"Dimmbar","lamps":"Leuchten / Driver"},"en":{"power":"Power","constantCurrent":"Constant Current","constantVoltage":"Constant Voltage","dimmable":"Dimmable","lamps":"Luminaires / Driver"}}')
  delete Component.options._Ctor
}
